export default "__VITE_ASSET__gyGAo15X__"